import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { GripSVG } from '@common_components/svg/grip.svg';

const GripIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <GripSVG/>
    </div>
  );
};

export { GripIcon };
